<template>
  <SrpModal size="large">
    <template #content>
      <div class="standard-page-header" style="margin-bottom: 40px">
        <h1 class="global-h1 standard-page-header__title">View All Photos</h1>
      </div>

      <LoaderNew v-if="isLoading" :borderWidth="3" style="width: 60px; margin: 0 auto 30px" />

      <SrpMasonry v-else :items="socialShareSummaryPayload?.assets ?? []" :columns="screenSize === 'mobile' ? 3 : 5">
        <template #default="{ item, rebuildMasonry }">
          <SrpFileThumbnail
            :fileName="item"
            thumbSize="thumb-med"
            style="margin-bottom: 10px"
            :isFixedAspectRatio="false"
            @imageLoad="rebuildMasonry"
            galleryPostfix="ViewAllPhotosModal"
            isEntireAreaClickable
          />
        </template>
      </SrpMasonry>
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import { inject, onMounted, Ref, ref } from "vue";
import ShareStopSummaryRepo from "@/repos/ShareStopSummaryRepo";

// Components
import SrpModal from "@components/ui/SrpModal.vue";
import SrpMasonry from "@components/ui/SrpMasonry.vue";
import LoaderNew from "@components/Loader/LoaderNew.vue";
import SrpFileThumbnail from "@components/ui/SrpFileThumbnail.vue";

// Types
import { SocialShareSummaryContentType, SocialShareSummaryPayload } from "@contracts/shareStop";
import { ScreenSize } from "@contracts/screenSize";

// Global variables & injections
const screenSize = inject("screenSize") as Ref<ScreenSize>;

// Pass one of contentSummaryId (a Topic's content source) or locationId (every photo for a saved Location, ex. Local Promotion).
const props = withDefaults(
  defineProps<{
    customerId: string;
    contentSummaryId?: string;
    locationId?: string;
    contentType?: SocialShareSummaryContentType;
  }>(),
  {
    contentSummaryId: "",
    locationId: "",
    contentType: SocialShareSummaryContentType.Photos,
  }
);

// Load assets ================================================================
const isLoading = ref<boolean>(true);
const socialShareSummaryPayload = ref<SocialShareSummaryPayload | null>(null);

onMounted(async () => {
  isLoading.value = true;

  socialShareSummaryPayload.value = props.locationId
    ? await ShareStopSummaryRepo.loadSocialShareSummaryPayloadForLocation(props.customerId, props.locationId, props.contentType)
    : await ShareStopSummaryRepo.loadSocialShareSummaryPayloadFromSummaryId(props.customerId, props.contentSummaryId, props.contentType);

  isLoading.value = false;
});
</script>

<style scoped lang="scss"></style>
